import { Typography } from '@material-ui/core';
import SpinnerIcon from '@material-ui/core/CircularProgress';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { FunctionComponent } from 'react';
import { useQuery } from 'react-query';
import * as store from 'store';
import { getReceipts } from '../api';
import ReceiptsView from './ReceiptsView';

interface ViewSlipsProps {
  orderID: string;
}
declare interface Receipt {
  orderID: string;
  shopperID: string;
  vendor: string;
  total: string;
  slipReference: string;
  imageURL: string;
  warning: string;
  timestamp: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    noData: {
      display: 'flex',
      justifyContent: 'center',
      padding: '2.5em 0',
    },
    list: {
      width: '50%',
      marginRight: theme.spacing(3),
    },

    itemText: {
      maxWidth: '50%',
    },
    button: {
      margin: theme.spacing(1),
      borderRadius: theme.spacing(1),
      float: 'right',
    },
    buttonContaainer: {
      display: 'block',
      height: theme.spacing(7),
    },
    centerAlignDialogActions: {
      justifyContent: 'center',
    },
    spinnerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px 0',
    },
  })
);

const ViewSlips: FunctionComponent<ViewSlipsProps> = (props) => {
  const { orderID } = props;
  const accessToken = store.get('spotlightAccessToken');
  const classes = useStyles();

  const { data, isLoading } = useQuery(['receipts', accessToken, orderID], () => getReceipts({ accessToken, orderID }));
  if (isLoading) {
    return (
      <div className={classes.spinnerWrapper}>
        <SpinnerIcon style={{ width: 25, height: 25, marginRight: 8 }} />
        <Typography variant="subtitle1">Loading Details...</Typography>
      </div>
    );
  }
  if (!data?.data.details.length) return <div className={classes.noData}>No slips found for this order</div>;
  return (
    <div>
      <div>
        {data?.data.details.map((receipt: Receipt) => (
          <ReceiptsView receipt={receipt} key={receipt.orderID} />
        ))}
      </div>
    </div>
  );
};

export default ViewSlips;
